import { render, staticRenderFns } from "./SportDisciplineForm.vue?vue&type=template&id=1cd9d094&"
import script from "./SportDisciplineForm.vue?vue&type=script&lang=js&"
export * from "./SportDisciplineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports